export default __webpack_public_path__ + "static/media/DQM.0233a0a2.png";